import React from 'react';
import { MessageDescriptor, FormattedMessage } from 'react-intl';

export const Section: React.FC<{ title: MessageDescriptor, otherTitle?: React.ReactElement }> = ({ title, otherTitle, children }) =>
    <section className="App__section section">
        <h2 className="section__sub-heading">
            <FormattedMessage {...title} />
            {otherTitle}
        </h2>
        {children}
    </section>